import { defaulLangTextValidation, defaultTTranslate, SORTING_DIRECTION } from 'src/constants/main';
import { ICategoryValidation, TCategoryEditable } from 'src/types/categories';
import { CATEGORIES_COLUMN_NAME, ICategoriesFilters } from 'src/view/screens/MenuManagementScreen/screens/CategoriesScreen/types/categories';

export const defaultCategory: TCategoryEditable = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  sort: 0,
  // keep description for future improvments,
  // because we have data from BE with description now
  description: defaultTTranslate,
  meta_description: defaultTTranslate,
  status: 1,
};

export const defaultCategoriesFilters: ICategoriesFilters = {
  search: '',
  availability: undefined,
  sort_field: CATEGORIES_COLUMN_NAME.NAME,
  sort_dir: SORTING_DIRECTION.ASCENDING,
};

export const defaultCategoryValidation: ICategoryValidation = {
  valid: true,
  name: defaulLangTextValidation,
};
